module.exports = __webpack_public_path__ + "img/9788989646150.979f31c1.jpg";